import { render, staticRenderFns } from "./BaseApp.vue?vue&type=template&id=3bbe03da&scoped=true&"
import script from "./BaseApp.vue?vue&type=script&lang=js&"
export * from "./BaseApp.vue?vue&type=script&lang=js&"
import style0 from "./BaseApp.vue?vue&type=style&index=0&id=3bbe03da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe03da",
  null
  
)

export default component.exports